import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { Storage } from '@ionic/storage';
import { HttpClient } from '@angular/common/http';
import { NavController, LoadingController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

@Injectable()
export class HelperService {
  Strings: any;

  constructor(public api: Api, private translate: TranslateService, private storage: Storage, private loadingCntrl: LoadingController, private http: HttpClient) { }

  saveData(data) {
    return this.api.post('app_user_profile', data);
  }

  updateAdditionalInfo(resourceplaningData) {
    return this.api.post('updateWizardResourceData', resourceplaningData);
  }

  getvisitorProfiles(visitorId, sessionId) {
    return this.api.get('app_user_profiles', { user_id: visitorId, session_id: sessionId });
  }

  getvisitorDetails(visitorId) {
    return this.api.get('getVisitorData', { visitor_id: visitorId });
  }

  createNewVisitor(data) {
    return this.api.post('app_user', data);
  }

  /**
   * Helper function to log the user
   * @param {Object} postData - Post data for login.Contains user email as well as user device info.
   */
  loginUser(postData: any) {
    return this.api.post('app_user_login', postData);
  }

  deletevisitor(profileid, sessionId) {
    return this.api.delete('app_user_profile/' + profileid);
  }

  updateUserDetails(postData) {
    return this.api.put('app_user/' + postData.visitor_id, postData);
  }

  updateLoginDate(data) {
    return this.api.post('update_login_date', data);
  }

  joinSession(visitorId, sessionId) {
    return this.api.post('user_sessions', { user_id: visitorId, session_id: sessionId });
  }

  getUserSessionList(visitorId) {
    return this.api.get('user_sessions/' + visitorId);
  }

  saveAdditionalInfoData(postData) {
    return this.api.post('updateWizardResourceData', postData);
  }
  getLocalFile(path) {
    return this.http.get(path);
  }

  getProfileData(profileId, visitorId) {
    return this.api.get('getAppVisitorProfileById', { visitor_id: visitorId, profile_id: profileId });
    // let apiURL = environment.api_invoke_url + '/getVisitorProfileById?;
    // return this.http.get(apiURL).map(res => res.json());
  }

  updateNameData(postData) {
    return this.api.post('app_user_profile', postData);
  }

  // fetchProfileDetails() {
  //   const profileId = localStorage.get('convergence_profile_id');
  //   const visitorId = localStorage.get('convergence_visitor_id');
  //   let apiURL = environment.api_invoke_url + '/getVisitorProfileById?visitor_id=' + visitorId + '&profile_id=' + profileId;
  //   return this.http.get(apiURL).map(res => res.json()).subscribe(response => {
  //     console.log('fetch details ', response);
  //     localStorage.set('profile_data', JSON.stringify(response[0]));
  //   });
  // }

  getProfileDetailsFromStorage() {
    return this.storage.get('profile_data');
    // return JSON.parse(localStorage.get('profile_data'));
  }

  setProfileToStorage(param, value) {
    let profileData = this.getProfileDetailsFromStorage();
    profileData[param] = value;
    localStorage.set('profile_data', JSON.stringify(profileData));
  }

  getSessionData(sessionId) {
    return this.api.get('getAppSessionDetails', { session_id: sessionId });
  }

  updateProfileStorage(key: string, value) {
    this.storage.get('profile_data').then(data => {
      let _profileData = JSON.parse(data);
      _profileData[key] = value;
      this.storage.set('profile_data', JSON.stringify(_profileData)).then(data => { }).catch((err) => {
        window.onerror('helper service page error saving profile data : ' + JSON.stringify(err), window.location.href, 110, 0);
      });
    }).catch((err) => {
      window.onerror('helper service page error getting profile data : ' + JSON.stringify(err), window.location.href, 113, 0);
    });
  }

  navigateToOverview(navCtrl: NavController) {
    let loader = this.loadingCntrl.create({ spinner: 'ios-small', showBackdrop: true });
    loader.present();
    this.storage.get('profile_data').then(data => {

      let _profileData = JSON.parse(data);
      this.saveData(_profileData).subscribe((response: any) => {

        if (response[0].insertId)
          _profileData.profiles_id = response[0].insertId;

        this.storage.set('profile_data', JSON.stringify(_profileData)).catch(err => {
          window.onerror('helper service page error saving profile data : ' + JSON.stringify(err), window.location.href, 129, 0);
        });

        loader.dismiss();
        navCtrl.setRoot('OverviewPage');

      }, (err) => {
        loader.dismiss();
        console.log(err);
        window.onerror('helper service page error saving profile data to server : ' + JSON.stringify(err), window.location.href, 138, 0);
      });

    }).catch((err) => {
      loader.dismiss();
      window.onerror('helper service page error getting profile data : ' + JSON.stringify(err), window.location.href, 143, 0);
    });
  }

  syncData(visitorId) {
    this.getUserSessionList(visitorId);
  }

  getLatestAppVersion() {
    return this.api.get('app_version').pipe(map((res: any) => JSON.parse(res)));
  }

  savePdp(data) {
    return this.api.post('setPDP', data);
  }

  share_report(data) {
    return this.api.post('shareReport', data)
  }

  delete_pdp(data) {
    return this.api.post('deletePDP', data)
  }

  getRoleName(value: string): string {
    var data
    this.translate.get(['ROLE_SUPPORT', 'ROLE_ADMINISTRATION', 'ROLE_COORDINATOR', 'ROLE_MANAGEMENT', 'ROLE_OPERATIONAL_DEV', 'ROLE_POLICY_DEV', 'ROLE_STRATEGY_DEV']).subscribe(dat => {
      data = dat
    }, (err) => {
      window.onerror('helper service page error translating getRoleName data : ' + JSON.stringify(err), window.location.href, 172, 0);
    })
    if (data)
      switch (value) {
        case '2': return '1.' + data.ROLE_SUPPORT.NAME;
        case '3': return '2.' + data.ROLE_ADMINISTRATION.NAME;
        case '4': return '3.' + data.ROLE_COORDINATOR.NAME;
        case '5': return '4.' + data.ROLE_MANAGEMENT.NAME;
        case '6': return '5.' + data.ROLE_OPERATIONAL_DEV.NAME;
        case '7': return '6.' + data.ROLE_POLICY_DEV.NAME;
        case '8': return '7.' + data.ROLE_STRATEGY_DEV.NAME;
      }
  }

  getCompetenceName(value: string): string {
    var data
    this.translate.get(['COMPETENCE_STARTER', 'COMPETENCE_CONFIRMED', 'COMPETENCE_EXPERIENCED', 'COMPETENCE_SPECIALIST', 'COMPETENCE_GURU']).subscribe(dat => {
      data = dat
    }, (err) => {
      window.onerror('helper service page error translating getCompetenceName data : ' + JSON.stringify(err), window.location.href, 191, 0);
    })
    if (data)
      switch (value) {
        case '2': return data.COMPETENCE_STARTER.SUB_TITLE1;
        case '3': return data.COMPETENCE_STARTER.SUB_TITLE2;
        case '4': return data.COMPETENCE_STARTER.SUB_TITLE3;
        case '5': return data.COMPETENCE_CONFIRMED.SUB_TITLE1;
        case '6': return data.COMPETENCE_CONFIRMED.SUB_TITLE2;
        case '7': return data.COMPETENCE_CONFIRMED.SUB_TITLE3;
        case '8': return data.COMPETENCE_EXPERIENCED.SUB_TITLE1;
        case '9': return data.COMPETENCE_EXPERIENCED.SUB_TITLE2;
        case '10': return data.COMPETENCE_EXPERIENCED.SUB_TITLE3;
        case '11': return data.COMPETENCE_SPECIALIST.NAME;
        case '12': return data.COMPETENCE_GURU.NAME;
      }
  }

  getPerformanceName(value: string): string {
    var data
    this.translate.get(['PERFORMANCE_UNSATISFACTORY', 'PERFORMANCE_IMPROVEMENT_NEEDED', 'PERFORMANCE_GOOD_STANDARDS', 'PERFORMANCE_HIGH_STANDARDS', 'PERFORMANCE_EXCELLENT', 'PERFORMANCE_OUTSTANDING']).subscribe(dat => {
      data = dat
    }, (err) => {
      window.onerror('helper service page error translating getPerformanceName data : ' + JSON.stringify(err), window.location.href, 214, 0, err);
    })
    if (data)
      switch (value) {
        case '2': return data.PERFORMANCE_UNSATISFACTORY.NAME;
        case '3': return data.PERFORMANCE_IMPROVEMENT_NEEDED.NAME;
        case '4': return data.PERFORMANCE_GOOD_STANDARDS.NAME;
        case '5': return data.PERFORMANCE_HIGH_STANDARDS.NAME;
        case '6': return data.PERFORMANCE_EXCELLENT.NAME;
        case '7': return data.PERFORMANCE_OUTSTANDING.NAME;
      }
  }

  getTalentName(value: string): string {
    var data
    this.translate.get(['TALENT_UNSATISFACTORY', 'TALENT_MARGINAL', 'TALENT_NEW_ENTRANT', 'TALENT_OK_CONTRIB', 'TALENT_CONSISTENT_CONTRIB', 'TALENT_RISING_STAR', 'TALENT_KEY_CONTRIB', 'TALENT_HIGH_POTENTIAL', 'TALENT_STAR']).subscribe(dat => {
      data = dat
    }, (err) => {
      window.onerror('helper service page error translating getTalentName data : ' + JSON.stringify(err), window.location.href, 232, 0);
    })
    if (data)
      switch (value) {
        case '6': return data.TALENT_KEY_CONTRIB.NAME;
        case '8': return data.TALENT_HIGH_POTENTIAL.NAME;
        case '9': return data.TALENT_STAR.NAME;
        case '4': return data.TALENT_OK_CONTRIB.NAME;
        case '5': return data.TALENT_CONSISTENT_CONTRIB.NAME;
        case '7': return data.TALENT_RISING_STAR.NAME;
        case '2': return data.TALENT_UNSATISFACTORY.NAME;
        case '3': return data.TALENT_MARGINAL.NAME;
        case '1': return data.TALENT_NEW_ENTRANT.NAME;

      }
  }
  getVisionName(value: string): string {
    var data
    this.translate.get(['VISION_PRIDO', 'VISION_STRUG', 'VISION_BETWEENER', 'VISION_NICE_PERSON', 'VISION_EMERGING', 'VISION_ROLE_MODEL']).subscribe(dat => {
      data = dat
    }, (err) => {
      window.onerror('helper service page error translating getVisionName data : ' + JSON.stringify(err), window.location.href, 253, 0);
    })
    if (data)
      switch (value) {
        case '5': return data.VISION_PRIDO.NAME;
        case '7': return data.VISION_ROLE_MODEL.NAME;
        case '4': return data.VISION_BETWEENER.NAME;
        case '6': return data.VISION_EMERGING.NAME;
        case '2': return data.VISION_STRUG.NAME;
        case '3': return data.VISION_NICE_PERSON.NAME;
      }
  }

  getRewardName(value: string): string {
    var data
    this.translate.get(['NO_CLUE', 'ABOVE_MEDIAN', 'MEDIAN', 'BELOW_MEDIAN']).subscribe(dat => {
      data = dat
    }, (err) => {
      window.onerror('helper service page error translating getRewardName data : ' + JSON.stringify(err), window.location.href, 271, 0);
    })
    if (data)
      switch (value) {
        case '4': return data.NO_CLUE;
        case '3': return data.ABOVE_MEDIAN;
        case '2': return data.MEDIAN;
        case '1': return data.BELOW_MEDIAN;
      }
  }

  getAttritionName(value: string) {
    var data
    this.translate.get('RISK_TEXTS').subscribe(dat => {
      data = dat
    }, (err) => {
      window.onerror('helper service page error translating getAttritionName data : ' + JSON.stringify(err), window.location.href, 287, 0);
    })
    if (data)
      switch (value) {
        case '2': return data.LOW;
        case '3': return data.MEDIUM;
        case '4': return data.HIGH;
        case '5': return data.VERY_HIGH;
      }

  }

  getFunctionalAreaName(value: string): string {
    switch (value) {
      case '1': return 'Fin & Admin';
      case '2': return 'HR';
      case '3': return 'IT';
      case '4': return 'Mktg';
      case '5': return 'Production';
      case '6': return 'R&D';
      case '7': return 'Sales';
      case '8': return 'Sales & Mktg';
      case '9': return 'Other';
    }
  }

  getTimeInCompanyText(value: string): string {
    switch (value) {
      case '1': return '0-4';
      case '2': return '5-9';
      case '3': return '10-14';
      case '4': return '15-19';
      case '5': return '20+';
    }
  }

  getMessageData() {
    return this.api.get('message').pipe(map((res: any) => JSON.parse(res)));;
  }

  checkAndSaveLangugae() {

    this.storage.get("selected_lang").then((lang) => {
      if (lang) {
        this.translate.use(lang.toLowerCase());
      }
      else
        this.saveAndSetLanguage();
    }).catch((err) => {
      this.saveAndSetLanguage();
      window.onerror('helper service page error getting selected lang data : ' + JSON.stringify(err), window.location.href, 337, 0);
    })

  }

  saveAndSetLanguage() {
    const browserLang = this.translate.getBrowserLang();
    if (browserLang) {
      if (browserLang === 'fr') {
        this.translate.use('fr');
        this.storage.set("selected_lang", 'FR')
        // }
      } else if (browserLang === 'nl') {
        this.translate.use('nl');
        this.storage.set("selected_lang", 'NL')
      } else if (browserLang === 'es') {
        this.translate.use('es');
        this.storage.set("selected_lang", 'ES')
      } else {
        this.translate.use('en');
        this.storage.set("selected_lang", 'EN')
      }
    } else {
      this.translate.use('en'); // Set your language here
      this.storage.set("selected_lang", 'EN')
    }
  }

  checkLoginSession() {
    return new Promise((resolve, reject) => {

      this.storage.get('visitor_id').then((id) => {
        // Visitor id is existing in storage. So app is not firs time opening.
        if (id) {
          this.storage.get('sessionData').then(sessionData => {

            let _sessionData = JSON.parse(sessionData);
            if (_sessionData && _sessionData.session_id)
              resolve('OverviewPage');
            else
              reject('JoinSessionPage');

          }, (err) => {

            window.onerror('helper service page error getting sessionData data : ' + JSON.stringify(err), window.location.href, 378, 0);
            reject('JoinSessionPage');

          }).catch((err) => {

            window.onerror('helper service page error getting sessionData data : ' + JSON.stringify(err), window.location.href, 383, 0);
            reject('WelcomePage');

          });
        }
        else
          reject('JoinSessionPage');

      }, (err) => {

        window.onerror('helper service page error getting visitor id data : ' + JSON.stringify(err), window.location.href, 393, 0);
        reject('WelcomePage');

      }).catch((err) => {

        window.onerror('helper service error getting visitor id data : ' + JSON.stringify(err), window.location.href, 398, 0);
        reject('WelcomePage');

      });
    })
  }

  checkSplashLoginSession() {
    return new Promise((resolve, reject) => {
      this.storage.get('visitor_id').then((id) => {
        // Visitor id is existing in storage. So app is not firs time opening.
        if (id) {
          this.storage.get('sessionData').then(sessionData => {
            let _sessionData = JSON.parse(sessionData);
            if (_sessionData && _sessionData.session_id) {
              this.getSessionData(_sessionData.session_id).subscribe((sessionData: any) => {

                if (sessionData && sessionData.session_status == 1)
                  resolve('OverviewPage');
                else
                  reject('JoinSessionPage');

              }, (err) => {
                window.onerror('helper service page error getting session data from server : ' + JSON.stringify(err), window.location.href, 421, 0);
                reject('JoinSessionPage');

              });
            }
            else
              reject('JoinSessionPage');

          }, (err) => {
            window.onerror('helper service page error getting session data : ' + JSON.stringify(err), window.location.href, 430, 0);
            reject('JoinSessionPage');
          });
        }
        else
          reject('JoinSessionPage');

      }, (err) => {
        window.onerror('helper service page error getting visitor id data : ' + JSON.stringify(err), window.location.href, 438, 0);
        reject('WelcomePage');

      }).catch((err) => {
        window.onerror('helper service page error getting visitor id data : ' + JSON.stringify(err), window.location.href, 442, 0);
        reject('WelcomePage');
      });
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/helper/helper.ts